import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeInRightAnimation } from '../../../@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from '../../../@fury/animations/scale-in.animation';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { Subject } from 'rxjs';
import { WebformService } from '../../services/reports/webform.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ServerResponse } from '../../interfaces/base/server.response';
import { AuthenticationService } from '../../services/base/authentication.service';
import { Title } from '@angular/platform-browser';
import { Organisation } from '../../interfaces/routering/organisation';

@Component({
  selector: 'fury-received',
  templateUrl: './received.component.html',
  styleUrls: ['./received.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ReceivedComponent implements OnInit, OnDestroy {

  public isLoading: boolean = true;

  private pageTitle: string = 'Uw melding hebben wij in goede orde ontvangen';

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private titleService: Title,
              public webformService: WebformService,
              public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.pageTitle + ' - Straatbeeld Online');
    this.authenticationService.organisation$.pipe(takeUntil(this.destroy$)).subscribe((organisation: Organisation): void => {
      if (organisation && typeof organisation.display_name !== 'undefined') {
        this.titleService.setTitle(this.pageTitle + ' - ' + organisation.display_name);
      }
    });

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params): void => {
      if (typeof params['unique_number'] !== 'undefined') {
        if (params['unique_number'] !== null) {
          this.webformService.get(params['unique_number']).subscribe((response: ServerResponse): void => {
            if (typeof response !== 'undefined') {
              if (typeof response.data !== 'undefined') {
                this.webformService.report = response.data;
                this.isLoading = false;
              } else {
                this.router.navigate(['/']).then((): void => {
                });
              }
            } else {
              this.router.navigate(['/']).then((): void => {
              });
            }
          }, () => {
            this.isLoading = false;
          });
        } else {
          this.router.navigate(['/']).then((): void => {
          });
        }
      } else {
        this.router.navigate(['/']).then((): void => {
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
